import React, { useEffect, useRef, useState } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import validator from 'validator';
import emailjs from '@emailjs/browser';


// Sample image imports – replace with your actual paths
import brand1 from "../assets/brands/1.png";
import brand2 from "../assets/brands/2.png";
import brand3 from "../assets/brands/3.png";
import brand4 from "../assets/brands/4.png";
import brand5 from "../assets/brands/5.png";
import brand6 from "../assets/brands/6.png";
import brand7 from "../assets/brands/7.png";
import brand8 from "../assets/brands/8.png";
import brand9 from "../assets/brands/9.png";
import brand10 from "../assets/brands/10.png";
import brand11 from "../assets/brands/11.png";
import brand12 from "../assets/brands/12.png";
import brand13 from "../assets/brands/13.png";
import brand14 from "../assets/brands/14.png";
import brand15 from "../assets/brands/15.png";
import brand16 from "../assets/brands/16.png";
import brand17 from "../assets/brands/17.png";
import brand18 from "../assets/brands/18.png";
import brand19 from "../assets/brands/19.png";
import brand20 from "../assets/brands/20.png";
import brand21 from "../assets/brands/21.png";
import brand22 from "../assets/brands/22.png";
import brand23 from "../assets/brands/23.png";
import brand24 from "../assets/brands/24.png";
import brand25 from "../assets/brands/25.png";
import brand26 from "../assets/brands/26.png";
import brand27 from "../assets/brands/27.png";
import brand28 from "../assets/brands/28.png";
import brand29 from "../assets/brands/29.png";

import logo1 from "../assets/insurance/1.png";
import logo2 from "../assets/insurance/2.png";
import logo3 from "../assets/insurance/3.png";
import logo4 from "../assets/insurance/4.png";
import logo5 from "../assets/insurance/5.png";
import logo6 from "../assets/insurance/6.png";
import logo7 from "../assets/insurance/7.png";
import logo8 from "../assets/insurance/8.png";
import logo9 from "../assets/insurance/9.png";
import logo10 from "../assets/insurance/10.png";
import logo11 from "../assets/insurance/11.png";
import logo12 from "../assets/insurance/12.png";
import logo13 from "../assets/insurance/13.png";
import logo14 from "../assets/insurance/14.png";
import logo15 from "../assets/insurance/15.png";
import logo16 from "../assets/insurance/16.png";

const brands = [
  brand1, brand2, brand3, brand4, brand5,
  brand6, brand7, brand8, brand9, brand10,
  brand11, brand12, brand13, brand14, brand15,
  brand16, brand17, brand18, brand19, brand20,
  brand21, brand22, brand23, brand24, brand25,
  brand26, brand27, brand28, brand29,
  ];
  
const logos = [  logo1, logo2, logo3, logo4, logo5, logo6, logo7, logo8, logo9, logo10, logo11, logo12, logo13, logo14, logo15, logo16,];


const BrandsPage = () => {
  const form = useRef(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  const sendEmail = (e) => {
    e.preventDefault();
    const data = new FormData(e.target);
    const name = data.get("firstName") + " " + data.get("lastName");
    const email = data.get("email");
    const phone = data.get("phone");

    if (validator.isEmail(email) && validator.isMobilePhone(phone)) {
      setLoading(true);
      emailjs.sendForm(
        "service_xv5joub",
        "template_8i175ia",
        form.current,
        "7tu756ZjTi0xVnRkq"
      ).then(
        () => {
          alert("Message sent!");
          document.getElementById("form").reset();
          setLoading(false);
        },
        (error) => {
          console.error(error.text);
          setLoading(false);
        }
      );
    } else {
      alert("Please enter a valid email and phone number!");
    }
  };
  return (
    <div>
    <section className="bg-white py-16 px-4 lg:px-20 text-center">
      <div  data-aos="fade-right" >
        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold font-manrope text-center text-[#3471B8] mb-2">
        Our brands
        </h2>
        <p className="text-[#343434] font-manrope text-[16px] font-medium mb-10">Shop trusted brands</p>
      </div>

      <div data-aos="zoom-out" className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 lg:grid-cols-5 gap-0 place-items-center">
        {brands.map((logo, index) => (
          <div key={index} className="w-40 h-24 flex items-center justify-center">
            <img
              src={logo}
              alt={`Brand ${index + 1}`}
              className="max-h-full max-w-full object-contain transition duration-300"
            />
          </div>
        ))}
      </div>

    </section>
    <section className="bg-white px-4 lg:px-24 text-center">
      <div data-aos="fade-right">
        <h2 className="text-3xl lg:text-4xl font-manrope font-bold text-[#3471B8] mb-2">
          Need help? We are just a message away
        </h2>
        <p className="text-[#343434] font-manrope text-[16px] font-medium mb-10 max-w-xl mx-auto">
          Confused between frames or wondering whether we have your favourite brand?
          Write to us and we will get back to you right away.
        </p>
      </div>
      <div data-aos="zoom-out">
          <form
            id="form"
            ref={form}
            onSubmit={sendEmail}
            className="max-w-2xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-4"
          >
            <input name="firstName" type="text" placeholder="First name" required className="p-3 rounded-md bg-[#99C3F41F] focus:outline-none col-span-1" />
            <input name="lastName" type="text" placeholder="Last name" required className="p-3 rounded-md bg-[#99C3F41F] focus:outline-none col-span-1" />
            <input name="phone" type="text" placeholder="Phone" required className="p-3 rounded-md bg-[#99C3F41F] focus:outline-none col-span-1" />
            <input name="email" type="email" placeholder="Email" required className="p-3 rounded-md bg-[#99C3F41F] focus:outline-none col-span-1" />
            <textarea name="message" placeholder="Message" rows="5" required className="p-3 rounded-md bg-[#99C3F41F] focus:outline-none col-span-1 md:col-span-2"></textarea>
            <div className="col-span-1 md:col-span-2">
              <button
                type="submit"
                className="w-32 bg-gradient-to-br from-[#3471B8] to-[#173252] text-white font-manrope px-6 py-3 rounded-md hover:opacity-90 transition"
              >
                {loading ? "Sending..." : "Submit"}
              </button>
            </div>
          </form>
        </div>
    </section>

    <section data-aos="fade-up" className="bg-white pt-6 px-4 md:pt-10 md:px-12 text-center">
      <h2 className="text-3xl lg:text-4xl font-manrope font-bold text-[#3471B8] mb-2">
        Our Insurance providers 
      </h2>
      <p className="text-[#343434] text-[16px] font-manrope font-medium mb-10 max-w-xl mx-auto">
        We are partnered with leading insurance providers that have comprehensive
        coverage for your glasses.
      </p>


      <div className="overflow-hidden relative border-2 border-grey rounded-lg">
        <div className="flex w-max animate-scroll hover:[animation-play-state:paused] space-x-12">
          {[...logos, ...logos].map((logo, index) => (
            <img
              key={index}
              src={logo}
              alt={`Logo ${index}`}
              className="h-20 w-auto transition duration-300"
            />
          ))}
        </div>
      </div>
    </section>


    </div>    
  );
};

export default BrandsPage;
